import { render, staticRenderFns } from "./companyCheck.vue?vue&type=template&id=2aa0c7b6&scoped=true&"
import script from "./companyCheck.vue?vue&type=script&lang=js&"
export * from "./companyCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0c7b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa0c7b6')) {
      api.createRecord('2aa0c7b6', component.options)
    } else {
      api.reload('2aa0c7b6', component.options)
    }
    module.hot.accept("./companyCheck.vue?vue&type=template&id=2aa0c7b6&scoped=true&", function () {
      api.rerender('2aa0c7b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/applyManage/companyAuth/companyCheck.vue"
export default component.exports